import { Component, OnInit } from '@angular/core';
import { CalcsService } from '../calcs.service';

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.css']
})
export class HomeOneComponent implements OnInit {

  properties = [
    {image: '../../assets/detached.png', title: 'Detached'},
    {image: '../../assets/semidetached.png', title: 'Semi-Detached'},
    {image: '../../assets/flat.png', title: 'Flat'},
    {image: '../../assets/terrace.png', title: 'Terraced'}
  ]

  constructor(public calcService: CalcsService) { }

  ngOnInit(): void {
  }
}
